import {
  SET_REDMINE,
  SET_PROJECT,
  SET_USER,
  SET_PROJECT_MEMBERSHIPS,
  SET_ISSUE_STATUSES,
  SET_ISSUE_FILTER,
  RESET_CURRENT,
} from "../actions";

const current = (state = {}, action) => {
  switch (action.type) {
    case SET_REDMINE:
      // const user = {...action.user}
      return (state = {
        ...state,
        ...action.redmineinfo,
        user: action.user,
      });
    case SET_PROJECT:
      // console.log('action: ', action.project)
      return (state = {
        ...state,
        ...action.project,
      });
    case SET_USER:
      // console.log('action: ', action.project)
      return (state = {
        ...state,
        ...action.user,
      });
    case SET_PROJECT_MEMBERSHIPS:
      let members = action.memberships.reduce((list, member) => {
        if (member.user) list.push(member);
        return list;
      }, []);
      return (state = {
        ...state,
        projectMembers: members,
      });
    case SET_ISSUE_STATUSES:
      return (state = {
        ...state,
        issueStatuses: action.issue_statuses,
      });
    case SET_ISSUE_FILTER:
      return (state = {
        ...state,
        issueFilter: {
          ...action.filter,
        },
      });
    default:
      return state;

    case RESET_CURRENT:
      return {};
  }
};

export default current;
